import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import GradeScoreDisplay from './GradeScoreDisplay';

const EvaluationCard = ({ data, title, gradeLabel, scoreLabel }) => {
  const parseGaps = (gapsData) => {
    if (!gapsData) return [];
    
    try {
      if (typeof gapsData === 'string') {
        const parsed = JSON.parse(gapsData.replace(/'/g, '"'));
        if (typeof parsed === 'object' && parsed !== null) {
          return Object.values(parsed);
        }
      }
      
      if (Array.isArray(gapsData)) {
        return gapsData;
      }
      
      if (typeof gapsData === 'object' && gapsData !== null) {
        return Object.values(gapsData);
      }
      
      return [];
    } catch (error) {
      if (typeof gapsData === 'string') {
        const matches = gapsData.match(/'([^']+)'/g);
        return matches ? matches.map(match => match.replace(/'/g, '')) : [];
      }
      return [];
    }
  };

  if (!data) return null;

  return (
    <Card sx={{ mb: 3, border: '1px solid #e0e0e0' }}>
      <CardContent>
        <Typography variant="h6" fontWeight="bold" sx={{ mb: 3 }}>
          {title}
        </Typography>
        
        {/* Grade and Score Display using Universal Component */}
        <Box sx={{ mb: 3 }}>
          <GradeScoreDisplay 
            grade={data.grade} 
            score={data.raw_score}
            size="medium"
            showLabels={true}
          />
        </Box>

        {/* Justification */}
        {data.justification && (
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>
              Assessment Summary
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {data.justification}
            </Typography>
          </Box>
        )}

        {/* Gaps */}
        {data.gaps_compared_to_target_job && (
          <Box>
            <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>
              Areas for Improvement
            </Typography>
            <Box component="ul" sx={{ pl: 2, m: 0 }}>
              {parseGaps(data.gaps_compared_to_target_job).map((gap, index) => (
                <Typography
                  component="li"
                  key={index}
                  variant="body2"
                  sx={{ color: 'text.secondary', mb: 0.5 }}
                >
                  {gap}
                </Typography>
              ))}
            </Box>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default EvaluationCard;